export default class MemberTypesJwtService {
  axiosIns = null

  jwtConfig = null

  constructor(axiosIns, jwtConfig) {
    this.axiosIns = axiosIns;
    this.jwtConfig = jwtConfig;
  }

  create(payload = {}) {
    return this.axiosIns.post(this.jwtConfig.main.memberTypesEndpoint, payload)
  }

  update(id, payload = {}) {
    return this.axiosIns.put(`${this.jwtConfig.main.memberTypesEndpoint}/${id}`, payload)
  }

  delete(id) {
    return this.axiosIns.delete(`${this.jwtConfig.main.memberTypesEndpoint}/${id}`)
  }

  list(params) {
    return this.axiosIns.get(this.jwtConfig.main.memberTypesEndpoint, {
      params
    })
  }
}
